import React from "react";
import { useSelector } from "react-redux";
import Marquee from "react-fast-marquee";
import { AiFillSound } from "react-icons/ai";

const MarqueeList = () => {
  const marqueeList = useSelector((state) => state.isMarqueeList);
  return (
    <section className="dark:bg-base-light-dark bg-base-light-white dark:text-base-light-white text-base-light-dark rounded-full flex items-center gap-[10px] py-[1.5px] px-common-padding-x">
      <AiFillSound className="" />

      <Marquee className="">
        {marqueeList?.map((item, index) => {
          return (
            <div key={`marquee-${index}`} className="mr-[15px]">
              {index + 1}. {item?.subject}
            </div>
          );
        })}
      </Marquee>
    </section>
  );
};

export default MarqueeList;
